module.exports = __webpack_public_path__ + "resources/img/main_banner_ngsc01_m.248c12e77f08971ddf6e0b26c6e8b502.png";